var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2791 25.9281L13.6544 20.2581L23.9489 10.9823C24.4047 10.5668 23.8551 10.3657 23.2519 10.7276L10.5446 18.7568L5.04882 17.0142C3.86924 16.6791 3.85583 15.8615 5.3169 15.2717L26.7236 7.01461C27.7021 6.57226 28.6404 7.25588 28.2651 8.75717L24.6191 25.9281C24.3644 27.1479 23.6272 27.4428 22.6085 26.8798L17.0591 22.7781L14.3916 25.3651C14.0833 25.6734 13.8286 25.9281 13.2791 25.9281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.02447ed0d03f0ce5464f5172f482efbf.svg";
export { ForwardRef as ReactComponent };